import { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export interface IStepperProps {
  currentStep?: number;
  steps?: string[];
}

export const Stepper: React.FC<IStepperProps> = (props) => {
  const { t } = useTranslation();

  const [steps, setSteps] = useState([
    t("components.common_values"),
    t("components.items"),
    t("components.signing"),
  ]);
  const [currentStep, setCurrentStep] = useState(1);
  const [complete, setComplete] = useState(false);

  useEffect(() => {
    if (props.steps) setSteps(props.steps);
    if (props.currentStep) {
      setCurrentStep(props.currentStep);
      setComplete(props.currentStep === (props.steps?.length || steps.length));
    }
  }, [props.steps, props.currentStep]);

  return (
    <div className="w-full flex items-center max-w-full">
      {steps?.map((step, i) => (
        <Fragment key={i}>
          {i > 0 && (
            <div className="flex-1 h-px bg-slate-300 min-w-[12px] self-center" />
          )}
          <div
            className={`w-6 h-6 shrink-0 flex items-center justify-center rounded-full font-semibold text-white ${
              complete || currentStep >= i + 1 ? "bg-green" : "bg-slate-300"
            }`}
          >
            {i + 1}
          </div>
          <span className="text-sm bg-slate-100 px-2 whitespace-nowrap shrink-0">
            {step}
          </span>
        </Fragment>
      ))}
    </div>
  );
};

export default Stepper;
